import React, { FC } from 'react'

import { cx } from '@linaria/core'
import { useLocation } from 'react-router-dom'

import { WithClassName, WithDataName } from 'common/types'
import { CardsSvg } from 'components/designSystem/svgr/CardsSvg'
import { MagnifierSvg } from 'components/designSystem/svgr/MagnifierSvg'
import { ratingPath } from 'components/page/RatingWave/Rating.paths'
import { searchPath } from 'components/page/Search/Search.paths'

import {
  activeCss,
  defaultCss,
  iconSizeCss,
  Link,
  Parent,
} from './TabBar.styled'
import { CreateProfileOrLoginBlockInner } from '../CreateProfileOrLoginBlockInner'
import { isActiveTab } from '../function/isActiveTab'

export const TabBarNotAuthorized: FC<
  WithClassName & WithDataName & { isMobileBar: boolean }
> = ({ isMobileBar, className, ...rest }) => {
  const { pathname } = useLocation()

  if (isMobileBar) {
    return (
      <Parent className={cx(className)} data-name={rest['data-name']}>
        <CreateProfileOrLoginBlockInner variant="inline" />
      </Parent>
    )
  }

  return (
    <Parent className={cx(className)} data-name={rest['data-name']}>
      <Link
        to={searchPath}
        className={cx(
          defaultCss,
          isActiveTab(pathname, searchPath) && activeCss
        )}
        data-name="link-main-menu__search-action"
      >
        <MagnifierSvg className={cx(iconSizeCss)} />
      </Link>
      <Link
        to={ratingPath}
        className={cx(
          defaultCss,
          isActiveTab(pathname, ratingPath) && activeCss
        )}
        data-name="link-main-menu__rating-action"
      >
        <CardsSvg className={cx(iconSizeCss)} />
      </Link>
    </Parent>
  )
}
